export enum UserType {
  CLIENT = 'CLIENT'
}
